import Button from '@material-ui/core/Button'
import classnames from 'classnames'
import * as React from 'react'

import { stepsData } from 'data/parentalInstructions'

const stepsWithNavigation = stepsData.filter(step => !!step.hasNavigation)

interface IProps {
  activeStep: number
  onClickNavItem: (id: number) => void
}

export const InstructionsNavList: React.FC<IProps> = ({
  activeStep,
  onClickNavItem
}) => (
  <ul className="nav-list">
    {stepsWithNavigation.map(({ id }) => (
      <li className="nav-list-item" key={id}>
        <Button
          disabled={id >= activeStep}
          classes={{
            root: classnames('nav-list-btn', {
              'nav-list-btn-active': id === activeStep
            })
          }}
          onClick={() => onClickNavItem(id)}
        >
          <span />
        </Button>
      </li>
    ))}
  </ul>
)



// WEBPACK FOOTER //
// ./src/components/ParentalInstructions/InstructionsNavList.tsx